"use strict";
const helpers_1 = require("./helpers");
class Results {
    totalInterestPaid = 0;
    totalPayments = 0;
    strategy = '';
    payments = [];
    constructor(data, strategy) {
        this.payments = [...data];
        this.totalInterestPaid = this.calculateTotalInterestPaid();
        this.totalPayments = data.length;
        this.strategy = strategy;
    }
    calculateTotalInterestPaid() {
        const value = this.payments.reduce((acc, item) => {
            const monthlyInterest = item.accounts.reduce((output, account) => {
                return output + account.accruedInterest;
            }, 0);
            return acc + monthlyInterest;
        }, 0);
        return (0, helpers_1.toCurrency)(value);
    }
}
module.exports = Results;
